export enum breakDownKeys {
  'quality' = 'Quality',
  'benefits' = 'Benefits',
  'convenience' = 'Convenience',
  'personalFit' = 'Personal fit',
  'verification' = 'Updated provider info',
}
export const RecommendationCriteriaMatch = {
  None: 'None',
  All: 'All',
  Some: 'Some',
};

export const RecommendationScoreMatch = {
  Excellent: 'Excellent',
  Good: 'Good',
  Low: 'Low',
};

const criteriaMatchDescriptions = {
  [RecommendationCriteriaMatch.None]: 'No Criteria Met',
  [RecommendationCriteriaMatch.All]: 'All Criteria Met',
  [RecommendationCriteriaMatch.Some]: 'Some Criteria Met',
};

const criteriaViewMatchStyle = {
  [RecommendationCriteriaMatch.None]: {
    backgroundColor: '$warning2',
  },
  [RecommendationCriteriaMatch.Some]: {
    backgroundColor: '#F3F3F3',
  },
  [RecommendationCriteriaMatch.All]: {
    backgroundColor: '#F0F9ED',
  },
};

const matchDescriptions = {
  [RecommendationScoreMatch.Excellent]: 'Excellent match',
  [RecommendationScoreMatch.Good]: 'Good match',
  [RecommendationScoreMatch.Low]: 'Low match',
};

const viewMatchStyle = {
  [RecommendationScoreMatch.Low]: {
    backgroundColor: '$warning2',
  },
  [RecommendationScoreMatch.Good]: {
    backgroundColor: '#F3F3F3',
  },
  [RecommendationScoreMatch.Excellent]: {
    backgroundColor: '#F0F9ED',
  },
};

const textMatchStyle = {
  [RecommendationScoreMatch.Low]: {
    color: '#C24E14',
  },
  [RecommendationScoreMatch.Good]: {
    color: '$gray7',
  },
  [RecommendationScoreMatch.Excellent]: {
    color: '$success1',
  },
};

const criteriaTextMatchStyle = {
  [RecommendationCriteriaMatch.None]: {
    color: '#C24E14',
  },
  [RecommendationCriteriaMatch.Some]: {
    color: '$gray7',
  },
  [RecommendationCriteriaMatch.All]: {
    color: '$success1',
  },
};

export const getMatchDescription = (match: string, key: string): string => {
  if (key === 'quality') {
    return (
      criteriaMatchDescriptions[match] ??
      criteriaMatchDescriptions[RecommendationCriteriaMatch.None]
    );
  }
  return (
    matchDescriptions[match] ?? matchDescriptions[RecommendationScoreMatch.Low]
  );
};

export const getChipbackgroundColor = (match: string, key: string): string => {
  if (key === 'quality') {
    return (
      criteriaViewMatchStyle[match]?.backgroundColor ??
      criteriaViewMatchStyle[RecommendationCriteriaMatch.None].backgroundColor
    );
  }
  return (
    viewMatchStyle[match]?.backgroundColor ??
    viewMatchStyle[RecommendationScoreMatch.Low].backgroundColor
  );
};

export const getChipTextColor = (match: string, key: string): string => {
  if (key === 'quality') {
    return (
      criteriaTextMatchStyle[match]?.color ??
      criteriaTextMatchStyle[RecommendationCriteriaMatch.None].color
    );
  }
  return (
    textMatchStyle[match]?.color ??
    textMatchStyle[RecommendationScoreMatch.Low].color
  );
};

export const isSuppressPremiumSmartchoice = (
  suppressStates,
  state: string
): string =>
  suppressStates
    ?.replace(/[\s,]+/g, ',')
    ?.split(',')
    ?.includes(state)
    ? 'Y'
    : 'N';

export const removeSpecialCharactersUsingMatch = (str: string): string =>
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  (str?.match(/[a-zA-Z0-9 ]/g) ?? [])?.join('');

export const calculateDaysDifference = (
  date1: Date | string,
  date2: Date | string
): number => {
  const oneDay = 24 * 60 * 60 * 1000;
  const firstDate = new Date(date1).getTime();
  const secondDate = new Date(date2).getTime();
  const difference = Math.abs(firstDate - secondDate);
  return Math.ceil(difference / oneDay);
};

export const getMatchCount = (...args: boolean[]): number =>
  args.filter((i) => i).length;

export const countAllMeasures = (val: number, ...args: boolean[]): number => {
  args.forEach((i) => {
    if (i) {
      val = val + 1;
    }
  });
  return val;
};

export const checkMatch = (item): boolean => item === 'y';

export const getMatchText = (match: string, text: string): string =>
  match === 'Excellent' || match === 'Good'
    ? text
    : '';
